import React, { useEffect, useState } from "react";
import UserContext from "./context/userContext.js";
import { Container } from "react-bootstrap";
import Routing from "./components/routing/routing.js";
import Header from "./components/base/header.js";
import Footer from "./components/base/footer.js";
import User from "./components/base/user.js";
import { useNavigate } from "react-router-dom";


export default function App() {
  const [token, setToken] = useState();
  const [clientID, setClientID] = useState();
  const [accessCode, setAccessCode] = useState();
  const [userType, setUserType] = useState();
  const [clientRequestId, setclientRequestId] = useState();

  const navigate = useNavigate();

  const loginProcess = (userDetail, accessCode) => {
    sessionStorage.setItem("token", userDetail.token);
    sessionStorage.setItem("accessCode", accessCode);
    sessionStorage.setItem("clientID", userDetail.clientID);
    sessionStorage.setItem("userType", userDetail.userType);
    sessionStorage.setItem("clientRequestId", userDetail.clientRequestId);

    setAccessCode(accessCode);
    setToken(userDetail.token);
    setClientID(userDetail.clientID);
    setUserType(userDetail.userType);
    setclientRequestId(userDetail.clientRequestId);
  };

  const logoutProcess = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("accessCode");
    sessionStorage.removeItem("clientID");
    sessionStorage.removeItem("userType");
    sessionStorage.removeItem("clientRequestId");

    setToken(null);
    setAccessCode(null);
    setClientID(null);
    setUserType(null);
    setclientRequestId(null);

    navigate("/");
  };

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    const clientID = sessionStorage.getItem("clientID");
    const accessCode = sessionStorage.getItem("accessCode");
    const userType = sessionStorage.getItem("userType");
    const clientRequestId = sessionStorage.getItem("clientRequestId");

    if (token) {
      setAccessCode(accessCode);
      setClientID(clientID);
      setToken(token);
      setUserType(userType);
      setclientRequestId(clientRequestId);
    } else {
      setToken(null);
      setClientID(null);
      setAccessCode(null);
      setUserType(null);
      setclientRequestId(null);
    }
  }, []);

  return (
    <>
      <Header />
      <div className="content">

        <Container>
          <UserContext.Provider
            value={{
              token,
              clientID,
              accessCode,
              userType,
              clientRequestId
            }}
          >
            <User logoutProcess={logoutProcess} />
            <Routing
              loginProcess={loginProcess}
              logoutProcess={logoutProcess}
            />
          </UserContext.Provider>
        </Container>
      </div>
      <Footer />
    </>
  );
}
